import { AppState } from '../state';
import { AffiliateOptionsModel } from './affiliate-options.reducer';
import { createSelector } from '@ngrx/store';

export const selectAffiliateOptions = (state: AppState): AffiliateOptionsModel => state.affiliateOptions;

export const selectAffiliateOptionsData = createSelector(selectAffiliateOptions, ({ data }: AffiliateOptionsModel) => data);
